import React from 'react';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';

import { useAuth } from '../../../../../../hooks/Auth';
import { FiCopy, FiSend } from 'react-icons/fi';
import { uuid } from 'uuidv4';

interface ICreateModule {
  lineData: Record<string, any>;
  reload: Function;
}

export default function DuplicateModule({
  reload,
  lineData,

}: ICreateModule): JSX.Element {
  const { handleApiErrors } = useAuth();
  const { addToast } = useToast();


  const handleSend = async (id: string): Promise<void> => {
    try {

      const current = await api.get(`/sales-products/${id}`);

      const item = {...current?.data};

      delete item?._id;
      delete item?.client_id;
      delete item?.client_id_response;
      delete item?.fields
      delete item?.fields_text

      item.ticket_hash = uuid();

      const response = await api.post(`/sales-products`,item);

      reload();
      addToast({ title: 'Duplicado!', type: 'success' });
    }
    catch (err) {
      handleApiErrors(err);
    }
  };

  const moduleUpdate = (id: string): JSX.Element => (
    lineData?.cortesy_hash_id ? <button className="lineIcon" title="Duplicar produto de cortesia" type="button" onClick={() => handleSend(id)}>
      <FiCopy />
    </button> : <></>
  );

  return moduleUpdate(lineData._id.toString());
}
